import { type Event, createEvent } from 'models';
import { queryClient, useMutation } from 'query';
import { handleAxiosError } from 'ui';
import type { ApiClientResponseError, ResponseErrorDataObject } from 'common/services';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: break circular dependency
import { getCalendarPrincipalEventsListQueryKey } from 'features/calendar/queries';
import { cancelEvent } from '../../services';
import { getNodeEventDetailQueryKey, getNodeEventsQueryKey } from '../keys';

type CancelEventParams = {
  eventId: string;
};

const defaultMutateOnError = (error: ApiClientResponseError<ResponseErrorDataObject>) => {
  handleAxiosError(error, 'Something went wrong. The event couldn’t be canceled.');
};

export const useCancelEventMutation = () =>
  useMutation<Event, CancelEventParams>({
    defaultMutateOnError,
    async mutationFn({ eventId }) {
      const { data } = await cancelEvent({ routeParams: { id: eventId } });

      return createEvent(data);
    },
    async onSuccess(_, { eventId }) {
      await queryClient.invalidateQueries({ queryKey: getNodeEventDetailQueryKey({ eventId }) });
      await queryClient.invalidateQueries({ queryKey: getNodeEventsQueryKey({}) });
      await queryClient.invalidateQueries({ queryKey: getCalendarPrincipalEventsListQueryKey({}) });
    },
  });
